export default "__VITE_ASSET__Dqoy6w2X__"